import LoginForm from "../components/login-form/login-form.component";

const Login = () => {
    return(
        <div>
            <LoginForm />
        </div>
    )
}

export default Login;